import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock, Send, ChevronDown } from 'lucide-react';
export function Contact() {
  return <main className="flex-grow bg-brand-light" data-id="element-301">
      <div className="bg-brand-navy py-20 relative overflow-hidden" data-id="element-302">
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }} data-id="element-303"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-304">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white mb-6" data-id="element-305">
            Connect With <span className="text-brand-amber" data-id="element-306">Our Team</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-307">
            Operational 24/7 for critical deployments and technical
            consultations.
          </motion.p>
        </div>
      </div>

      <section className="py-20" data-id="element-308">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-309">
          <div className="flex flex-col lg:flex-row bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-310">
            {/* Contact Form (Left) */}
            <div className="lg:w-3/5 p-8 md:p-12" data-id="element-311">
              <h2 className="text-3xl font-heading font-bold text-brand-navy mb-2" data-id="element-312">
                Submit an Inquiry
              </h2>
              <p className="text-brand-slate mb-8" data-id="element-313">
                Provide your details below and an engineering consultant will
                respond promptly.
              </p>

              <form className="space-y-6" data-id="element-314">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-315">
                  <div data-id="element-316">
                    <label className="block text-sm font-bold text-brand-navy mb-2" data-id="element-317">
                      First Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 rounded bg-brand-light border border-gray-200 focus:border-brand-amber focus:ring-1 focus:ring-brand-amber outline-none transition-all" data-id="element-318" />
                  </div>
                  <div data-id="element-319">
                    <label className="block text-sm font-bold text-brand-navy mb-2" data-id="element-320">
                      Last Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 rounded bg-brand-light border border-gray-200 focus:border-brand-amber focus:ring-1 focus:ring-brand-amber outline-none transition-all" data-id="element-321" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-322">
                  <div data-id="element-323">
                    <label className="block text-sm font-bold text-brand-navy mb-2" data-id="element-324">
                      Email Address
                    </label>
                    <input type="email" className="w-full px-4 py-3 rounded bg-brand-light border border-gray-200 focus:border-brand-amber focus:ring-1 focus:ring-brand-amber outline-none transition-all" data-id="element-325" />
                  </div>
                  <div data-id="element-326">
                    <label className="block text-sm font-bold text-brand-navy mb-2" data-id="element-327">
                      Contact Number
                    </label>
                    <input type="tel" className="w-full px-4 py-3 rounded bg-brand-light border border-gray-200 focus:border-brand-amber focus:ring-1 focus:ring-brand-amber outline-none transition-all" data-id="element-328" />
                  </div>
                </div>

                <div data-id="element-329">
                  <label className="block text-sm font-bold text-brand-navy mb-2" data-id="element-330">
                    Equipment Category
                  </label>
                  <div className="relative" data-id="element-331">
                    <select className="w-full px-4 py-3 rounded bg-brand-light border border-gray-200 focus:border-brand-amber focus:ring-1 focus:ring-brand-amber outline-none transition-all appearance-none" data-id="element-332">
                      <option data-id="element-333">Select equipment type...</option>
                      <option data-id="element-334">Temporary Boilers</option>
                      <option data-id="element-335">Portable Heaters</option>
                      <option data-id="element-336">Industrial Chillers</option>
                      <option data-id="element-337">Cooling Systems</option>
                      <option data-id="element-338">General Inquiry</option>
                    </select>
                    <ChevronDown className="absolute right-4 top-3.5 w-5 h-5 text-gray-400 pointer-events-none" data-id="element-339" />
                  </div>
                </div>

                <div data-id="element-340">
                  <label className="block text-sm font-bold text-brand-navy mb-2" data-id="element-341">
                    Project Details
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 rounded bg-brand-light border border-gray-200 focus:border-brand-amber focus:ring-1 focus:ring-brand-amber outline-none transition-all resize-none" data-id="element-342"></textarea>
                </div>

                <button type="button" className="inline-flex items-center justify-center px-8 py-4 bg-brand-navy text-white font-bold rounded hover:bg-brand-amber transition-colors duration-300 w-full md:w-auto" data-id="element-343">
                  Transmit Request
                  <Send className="ml-2 w-4 h-4" data-id="element-344" />
                </button>
              </form>
            </div>

            {/* Contact Info (Right) */}
            <div className="lg:w-2/5 bg-brand-navy p-8 md:p-12 text-white" data-id="element-345">
              <h3 className="text-2xl font-heading font-bold mb-8" data-id="element-346">
                Direct Contact
              </h3>

              <div className="space-y-8 mb-12" data-id="element-347">
                <div className="flex items-start" data-id="element-348">
                  <div className="bg-white/10 p-3 rounded mr-4" data-id="element-349">
                    <Phone className="w-6 h-6 text-brand-amber" data-id="element-350" />
                  </div>
                  <div data-id="element-351">
                    <p className="text-sm text-gray-400 font-medium mb-1" data-id="element-352">
                      24/7 Dispatch Control
                    </p>
                    <a href="tel:08004647025" className="text-xl font-bold hover:text-brand-amber transition-colors" data-id="element-353">
                      0800 464 7025
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-354">
                  <div className="bg-white/10 p-3 rounded mr-4" data-id="element-355">
                    <Mail className="w-6 h-6 text-brand-amber" data-id="element-356" />
                  </div>
                  <div data-id="element-357">
                    <p className="text-sm text-gray-400 font-medium mb-1" data-id="element-358">
                      Corporate Email
                    </p>
                    <a href="mailto:info@rapidenergy.co.uk" className="text-lg font-bold hover:text-brand-amber transition-colors" data-id="element-359">
                      info@rapidenergy.co.uk
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-360">
                  <div className="bg-white/10 p-3 rounded mr-4" data-id="element-361">
                    <Clock className="w-6 h-6 text-brand-amber" data-id="element-362" />
                  </div>
                  <div data-id="element-363">
                    <p className="text-sm text-gray-400 font-medium mb-1" data-id="element-364">
                      Operational Status
                    </p>
                    <p className="text-lg font-bold" data-id="element-365">Active 24 Hours</p>
                  </div>
                </div>
              </div>

              <div className="border-t border-white/10 pt-8" data-id="element-366">
                <h4 className="font-heading font-bold text-lg mb-4 flex items-center" data-id="element-367">
                  <MapPin className="w-5 h-5 text-brand-amber mr-2" data-id="element-368" />
                  Logistics Hubs
                </h4>
                <div className="space-y-3" data-id="element-369">
                  <details className="group bg-white/5 rounded p-3 cursor-pointer" data-id="element-370">
                    <summary className="font-medium outline-none flex justify-between items-center" data-id="element-371">
                      Southern Region
                      <ChevronDown className="w-4 h-4 group-open:rotate-180 transition-transform" data-id="element-372" />
                    </summary>
                    <p className="text-sm text-gray-400 mt-2 pl-2 border-l-2 border-brand-amber" data-id="element-373">
                      Servicing London and the South East with sub-4 hour
                      response capability.
                    </p>
                  </details>
                  <details className="group bg-white/5 rounded p-3 cursor-pointer" data-id="element-374">
                    <summary className="font-medium outline-none flex justify-between items-center" data-id="element-375">
                      Midlands Hub
                      <ChevronDown className="w-4 h-4 group-open:rotate-180 transition-transform" data-id="element-376" />
                    </summary>
                    <p className="text-sm text-gray-400 mt-2 pl-2 border-l-2 border-brand-amber" data-id="element-377">
                      Centralized distribution for rapid deployment across the
                      Midlands.
                    </p>
                  </details>
                  <details className="group bg-white/5 rounded p-3 cursor-pointer" data-id="element-378">
                    <summary className="font-medium outline-none flex justify-between items-center" data-id="element-379">
                      Northern Hub
                      <ChevronDown className="w-4 h-4 group-open:rotate-180 transition-transform" data-id="element-380" />
                    </summary>
                    <p className="text-sm text-gray-400 mt-2 pl-2 border-l-2 border-brand-amber" data-id="element-381">
                      Comprehensive coverage for the North West, North East, and
                      Scotland.
                    </p>
                  </details>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}